import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource, MatPaginator } from '@angular/material';
import { Title } from '@angular/platform-browser';
import { LoadingService } from 'src/app/_services/loading.service';
import { NotificationService } from 'src/app/_services/notification.service';
import { ProductService } from '../../_ecomservices/product.service';
import { DatePipe } from '@angular/common';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-product-list',
  templateUrl: './product-list.component.html',
  styleUrls: ['./product-list.component.css']
})    
export class ProductListComponent implements OnInit {

  siteUrl = environment.siteUrl;
  
  product_list = [];

  displayedColumns: string[] = ['SLNo', 'ProductImage', 'Product', 'Category', 'Date'];
  
  dataSource: MatTableDataSource<any>;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  searchKey: string;

  constructor(
    public datePipe: DatePipe,
    private titleService: Title,
    public productService: ProductService,
    private loading : LoadingService,
    private notificationService: NotificationService,) { }

  ngOnInit() {
    this.titleService.setTitle('Product List');
    this.onLoadProducts();
  }

  onLoadProducts() {
    var result = this.productService.get_products().subscribe(data=> {
      console.log(data);
      // console.log(this.dataSource.data);
      this.product_list = data['productList'];
      this.dataSource = new MatTableDataSource<any>(data['productList']);
      this.dataSource.paginator = this.paginator;
    });
  }

  applyFilter()
  {
    this.dataSource.filter = this.searchKey.trim().toLocaleLowerCase();
  }

  onSearchClear()
  {
    this.searchKey = "";
    this.applyFilter();
  }


  onCreate() {

  }

  onTabChanged(obj)
  {

  }

   
  productStatusList = [
    // { label: "All Products", status: "all" },
    { label: "Publish Products", status: 1 },
    { label: "Draft Products", status: 0 },
    { label: "Trash Products", status: -1 }
  ];

  getFilteredProducts(status: string | number) {
    if (status === "all") return new MatTableDataSource(this.product_list);
    return new MatTableDataSource(this.product_list.filter(product => product.status === status));
  }

  

}

